import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";

const HealthBloodList = ({ items = [], onView, className, onUpdate }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Health blood has been added yet</strong>
            </div>
        );
    return (
        <div className={`${className}`}>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">SN</th>
                        <th scope="col-4">Comment</th>
                        <th scope="col">Staff</th>
                        <th scope="col" className="text-center">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="inbox-small-cells">
                                <div className="todo-check pull-left">{index + 1}</div>
                            </td>
                            <td className="view-message">
                                <span>{item.comment}</span>
                                <br />
                                <small className="text-muted">
                                    <TimeAgo date={item.created_at}></TimeAgo>
                                </small>
                            </td>

                            <td className="view-message">
                                <StaffProfileCard item={item.author} />
                            </td>

                            <td className="view-message text-center">
                                {item.attachment && (
                                    <button
                                        onClick={() => {
                                            document.location.href = item.attachment;
                                        }}
                                        title="Download Attachment"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored mdl-button--primary"
                                    >
                                        <i className="material-icons">cloud_download</i>
                                    </button>
                                )}
                                <button onClick={() => onView(item)} title="View Detail" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored mdl-button--primary">
                                    <i className="material-icons text-primary">trending_flat</i>
                                </button>
                                <button onClick={() => onUpdate(item)} title="Update" className="mdl-button mdl-button--icon mdl-button--colored">
                                    <i className="material-icons text-primary">edit</i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default HealthBloodList;
